import { MdenunciaContenedorC } from './MdenunciaContenedorC';
import { DatosGeneral } from './DatosGeneral';

export class MformularioWebC {
    mDenunciaContenedorC: MdenunciaContenedorC;
    datosGeneral: DatosGeneral;
}
